import React from 'react';
import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AdminContext } from 'constants/contexts';

/**
 * Renders children only for Django superusers; otherwise redirects to console.
 */
function RequireSuperuser({ children }) {
  const { user, isLoggedIn } = useContext(AdminContext);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.is_superuser) {
    return <Navigate to="/console" replace />;
  }

  return children;
}

export default RequireSuperuser;
